import { render, staticRenderFns } from "./sub_notice3.vue?vue&type=template&id=3a9e72ec&scoped=true&"
import script from "./sub_notice3.vue?vue&type=script&lang=js&"
export * from "./sub_notice3.vue?vue&type=script&lang=js&"
import style0 from "./sub_notice3.vue?vue&type=style&index=0&id=3a9e72ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e72ec",
  null
  
)

export default component.exports